import { useSelector } from 'react-redux'
import { getCurrentUser } from 'features/auth/ducks/selectors'
import { getSelectedBp } from 'features/bpDetails/ducks/selectors'
import { useGuruContext } from './useGuruContext'

export function useGuruVisibility() {
  const { contextType, contextId } = useGuruContext()
  const user = useSelector(getCurrentUser)
  const bp = useSelector(getSelectedBp)

  if (!user || !contextType) return false
  // 'user' context (global / across all my BPs) has no contextId — that's OK.
  if (contextType !== 'user' && !contextId) return false
  if (contextType === 'bp' && bp?.id === contextId && bp?.status && bp.status !== 'active') return false
  return true
}
